import { useState } from "react"
import { Button, Col, Container, Row, Stack } from "react-bootstrap"
import { useParams } from "react-router"
import { navigateTo } from "../../../redux/router/routerActions"
import { useAppDispatch } from "../../../redux/store"
import { useDeleteNotificationEntryMutation, useGetNotificationEntryByIdQuery } from "../../../services/bClientApi"
import { accountSelector } from "../../../redux/account/accountSlice"
import { useSelector } from "react-redux"

export default function DeleteNotificationEntryPage() {

    const [
        deleteNotificationEntry,
        {
            isLoading: deleteLoading,
            error: deleteError
        }
    ] = useDeleteNotificationEntryMutation()

    const { notificationEntryId = '' } = useParams()
    const dispatch = useAppDispatch()

    const [deleteClicked, setDeleteClicked] = useState(false)

    const { _id: currentUserId } = useSelector(accountSelector)

    const {
        data,
        error,
        isLoading
      } = useGetNotificationEntryByIdQuery(notificationEntryId, { skip: !notificationEntryId || deleteClicked })
      const notificationEntryData = data || {}


    const notificationEntryDeleteFn = async () => {
        if (notificationEntryId) {
            const deleteValue = await deleteNotificationEntry(notificationEntryId).unwrap()
            if (deleteValue) {
                dispatch(navigateTo(data.userId === currentUserId ? `/my-notifications/` : `/notification-entries/`))
            }
        }
    }

    return (
        <Container>
            <Row>
                <Col>
                    <h1>Delete Notification Entry Page</h1>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}
                    {deleteError && (<>{JSON.stringify(deleteError)}<br /></>)}

                    {notificationEntryId && notificationEntryData && !isLoading && (
                        <div className="notification-entry-info">
                            {JSON.stringify(notificationEntryData)}

                            <Stack gap={3}>
                                <div>Are you sure you want to delete Notification Entry: {notificationEntryId}</div>
                                <div>
                                    <Button variant={'warning'} onClick={() => setDeleteClicked(true)}>Delete Notification Entry</Button>
                                </div>
                                {deleteClicked && (
                                    <div>
                                        Once you delete this notification entry it will be gone forever. <br />
                                        <Button variant={'danger'} disabled={deleteLoading} onClick={() => {
                                            notificationEntryDeleteFn()
                                        }}> Confirm Delete Notification Entry </Button>
                                    </div>
                                )}
                            </Stack>

                        </div>
                    )}
                </Col>
            </Row>
        </Container>
    )
}
